export const SHARE_PAGE = 'share-page';
